import React from "react";
import RevealSection from "../RevealSection";
import { useInView } from "../../hooks/useInView";

const BOARD_ITEMS = [
  "Revenue from recruiters, not you",
  "No job freshness signals",
  "No company risk signals",
  "Keyword matching only",
  "Your data sold to employers",
  "No hiring-volatility read",
];

const GUMI_ITEMS = [
  "We work for you. Only you.",
  "Job freshness signals built in",
  "Company stability + hiring volatility",
  "AI-powered fit scoring",
  "Your data never sold",
  "Alerts when a job you applied to is removed",
];

export const Comparison = () => {
  return (
    <section
      data-testid="comparison-section"
      style={{ background: "white", padding: "100px 24px", textAlign: "center" }}
    >
      <RevealSection>
        <p
          className="font-body"
          style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: "#1D9E75",
            marginBottom: 16,
          }}
        >
          WHY GUMI
        </p>
      </RevealSection>

      <RevealSection>
        <h2
          className="font-heading"
          style={{
            fontSize: "clamp(32px, 5vw, 52px)",
            fontWeight: 700,
            letterSpacing: "-1px",
            lineHeight: 1.1,
            color: "#1a1a18",
            maxWidth: 600,
            margin: "12px auto 48px",
          }}
        >
          They work for employers. We work for you.
        </h2>
      </RevealSection>

      <div
        className="comparison-cards"
        style={{
          maxWidth: 800,
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 24,
          textAlign: "left",
        }}
      >
        <ComparisonCard
          slideFrom="left"
          hoverClassName="comparison-card-left"
          style={{ background: "white", border: "0.5px solid #e5e5e3", borderRadius: 16, padding: 28 }}
          headline="Job boards"
          headlineColor="#5f5e5a"
          items={BOARD_ITEMS}
          icon="❌"
          itemColor="#5f5e5a"
          borderColor="#f0f0ee"
        />

        <ComparisonCard
          slideFrom="right"
          hoverClassName="comparison-card-right"
          style={{ background: "#1a1a18", borderRadius: 16, padding: 28, boxShadow: "0 20px 60px rgba(0,0,0,0.15)" }}
          headline="GuMi"
          headlineColor="#1D9E75"
          headlineWeight={700}
          items={GUMI_ITEMS}
          icon="✅"
          itemColor="white"
          borderColor="rgba(255,255,255,0.1)"
        />
      </div>
    </section>
  );
};

// Two nested elements on purpose: the outer one owns the scroll-entrance
// slide (its `transition` is opacity/transform on mount-into-view), the
// inner one owns the hover lift (its own `transition` on pointer hover).
// Both would fight over the `transition` shorthand if merged onto one node.
const ComparisonCard = ({ slideFrom, hoverClassName, style, headline, headlineColor, headlineWeight = 600, items, icon, itemColor, borderColor }) => {
  const { ref, inView } = useInView(0.15);

  return (
    <div
      ref={ref}
      className={`card-reveal-${slideFrom} ${inView ? "visible" : ""}`}
      data-testid={`comparison-card-${slideFrom}`}
    >
      <div className={hoverClassName} style={style}>
        <p className="font-body" style={{ fontSize: 13, fontWeight: headlineWeight, color: headlineColor }}>
          {headline}
        </p>
        <ul role="list" style={{ marginTop: 12 }}>
          {items.map((item) => (
            <li
              role="listitem"
              key={item}
              className="font-body"
              style={{
                display: "flex",
                gap: 10,
                padding: "10px 0",
                borderBottom: `0.5px solid ${borderColor}`,
                fontSize: 14,
                color: itemColor,
              }}
            >
              <span aria-hidden="true">{icon}</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Comparison;
